import React, { useEffect, useState } from 'react';
import { Button, Text } from 'grommet';
import { DownloadOption } from 'grommet-icons';
import { analytics } from '../../../services/analytics';
import { FetchClipRequest, ToastData } from '../hitScope.types';
import useDownloadClips from '../../../hooks/useDownloadClips';
import HitScopeToast from './HitScopeToast';
import useHitScope from '../useHitscope';

interface HitScopeDownloadButtonProps {
  numberOfClips: number;
  title: string;
  downloadRequest: FetchClipRequest;
  type: 'player' | 'team' | 'game';
}

const HitScopeDownloadButton: React.FC<HitScopeDownloadButtonProps> = ({
  numberOfClips,
  title,
  downloadRequest,
  type,
}) => {
  const { downloadClips } = useDownloadClips();
  const { downloadHitScopeClips, downloadStatus } = useHitScope({
    type: type,
  });

  const [toast, setToast] = useState<ToastData | undefined>(downloadStatus);
  useEffect(() => {
    setToast(downloadStatus);
  }, [downloadStatus]);

  const onDownloadClicked = () => {
    analytics.track('Download HitScope Clicked', {
      type: 'Player',
    });
    downloadHitScopeClips(downloadRequest, numberOfClips);
    //setToast(downloadStatus);
  };

  const handleDownloadClip = (url: string | undefined) => {
    if (!url) {
      return;
    }
    downloadClips(url, title);
  };

  return (
    <>
      <Button
        plain
        color="secondary-1"
        icon={<DownloadOption size="20px" color="secondary-1" />}
        label={<Text size="small">Download</Text>}
        id="download-clip-unclaimed"
        onClick={onDownloadClicked}
        alignSelf="start"
      />
      {downloadStatus ? (
        <HitScopeToast
          handleDownloadClip={handleDownloadClip}
          toast={toast}
          setToast={setToast}
        />
      ) : null}
    </>
  );
};

export default HitScopeDownloadButton;
